import state from './leaseState'
import mutations from './leaseMutations'
import actions from './leaseActions'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
